"use client";
import Home from "@/components/sharedComponents/Home";

export default function HomePage() {
  return <Home />;
}
